import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 0.5L7.5451 3.63074L11 4.13262L8.5 6.56738L9.0902 10L6 8.38074L2.9098 10L3.5 6.56738L1 4.13262L4.4549 3.63074L6 0.5Z",
		fill: "currentColor"
	})
});
export default SvgStar;
